import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/grid';
import { Navigation, Pagination, Grid } from 'swiper/modules';
export default class TextCardsList {
    constructor() {
        this.section = document.querySelector('.components-block-text-cards-list');
        this.slider = this.section.querySelector('.swiper');
        this.navigationPrev = this.section.querySelector('.slider-button-prev');
        this.navigationNext = this.section.querySelector('.slider-button-next');
        this.pagination = this.section.querySelector('.swiper-pagination-nav');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination, Grid],
            grabCursor: true,
            slidesPerView: 3,
            spaceBetween: 40,
            grid: {
                rows: 3,
                fill: 'row',
            },
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                },
                1024: {
                    slidesPerView: 3,
                    pagination: '',
                },
            },
        });
    }
}

if (document.querySelector('.components-block-text-cards-list')) {
    new TextCardsList();
}
